import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "dropdown d-inline-block mr-1" }
const _hoisted_7 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_8 = {
  class: "dropdown-menu",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "dropdown d-inline-block" }
const _hoisted_11 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_12 = { class: "dropdown-menu" }
const _hoisted_13 = ["onClick"]

import { ref, computed, toRef } from 'vue'

    import { KendoChart } from '@Kendo/Components/KendoChart'
    import type { RadarChartDialogViewModel } from '@Evaluation/ValueAnalysis/Components/RadarChartDialog'
    import type { CriterionReadModel } from '../Domain/readmodels'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RadarChartDialog',
  props: {
    viewModel: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- local state ----------------

    const topLevel = ref(true)

    const themes = [
        'default',
        'black',
        'blueopal',
        'bootstrap',
        'highcontrast',
        'metro',
        'metroblack',
        'moonlight',
        'silver',
        'uniform'
    ]

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const theme = computed<string>({
        get: () => vm.value.theme,
        set: val => { vm.value.theme = val }
    })

    const selectedCriterionName = computed<string | null>(() =>
        vm.value.selectedCriterion?.Name ?? null
    )

    const chart = computed<KendoChart>(() => vm.value.chart)

    const criteria = computed<CriterionReadModel[]>(() => vm.value.criteria)

    const parents = computed<CriterionReadModel[]>(() =>
        criteria.value.filter(c => c.IsParent === true)
    )

    // ---------------- actions ----------------

    function handleChangeCriterion(criterionId: number)
    {
        if (criterionId !== vm.value.criterionId)
        {
            vm.value.criterionId = criterionId
            vm.value.setChartData(topLevel.value)
        }
    }

    function handleChangeTheme(t: string)
    {
        if (t !== theme.value)
        {
            theme.value = t
            chart.value.SetTheme(t)
        }
    }

    function handleToggleLevel()
    {
        topLevel.value = !topLevel.value
        vm.value.setChartData(topLevel.value)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (opened.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", { class: "modal-header" }, [
                  _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Radar chart", -1 /* CACHED */)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    onClick: close
                  }, "×")
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", _hoisted_7, _toDisplayString(selectedCriterionName.value), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parents.value, (c) => {
                          return (_openBlock(), _createElementBlock("a", {
                            class: "dropdown-item",
                            key: c.Id,
                            onClick: ($event: any) => (handleChangeCriterion(c.Id))
                          }, _toDisplayString(c.Name), 9 /* TEXT, PROPS */, _hoisted_9))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary mr-1",
                      onClick: handleToggleLevel
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa-regular fa-fw", topLevel.value ? 'fa-square' : 'fa-square-check'])
                      }, null, 2 /* CLASS */),
                      _cache[1] || (_cache[1] = _createTextVNode(" Bottom level ", -1 /* CACHED */))
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", _hoisted_11, _toDisplayString(theme.value), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_12, [
                        _cache[2] || (_cache[2] = _createElementVNode("h6", { class: "dropdown-header" }, "Color theme:", -1 /* CACHED */)),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(themes, (t) => {
                          return _createElementVNode("a", {
                            class: "dropdown-item",
                            key: t,
                            onClick: ($event: any) => (handleChangeTheme(t))
                          }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_13)
                        }), 64 /* STABLE_FRAGMENT */))
                      ])
                    ])
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"max-height":"calc(100vh-200px)","overflow":"auto"} }, [
                    _createElementVNode("div", { id: "Chart-RadarChart" })
                  ], -1 /* CACHED */))
                ]),
                _createElementVNode("div", { class: "modal-footer" }, [
                  _createElementVNode("button", {
                    onClick: close,
                    type: "button",
                    class: "btn btn-outline-secondary"
                  }, "Close")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})